<template>
  <page-list
    :list="list"
    :columns="columns"
    :showCheckbox="false" />
</template>

<script>
import * as R from 'ramda'
import ColumnsMixin from '../mixins/columns'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'SubscriptionList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin],
  props: {
    id: String,
    getParams: {
      type: [Function, Object],
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'billing_subscriptions',
        getParams: this.getParam,
      }),
    }
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = { ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams) }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BillSubscriptionSidePage', {
        id: row.id,
        resource: 'billing_subscriptions',
        getParams: this.getParam,
        currentTab: 'bill-order-list',
      }, {
        list: this.list,
      })
    },
  },
}
</script>
